import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { GlobalSearchResult } from "../types";
import { SearchResultItem } from "./SearchResultItem";

interface SearchResultsProps {
  results: GlobalSearchResult[];
  selectedIndex: number;
  hasKeyboardNavigation: boolean;
  onResultClick: (result: GlobalSearchResult) => void;
  onResultOpenInNewTab: (result: GlobalSearchResult) => void;
  isOtherMatch?: boolean;
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  selectedIndex,
  hasKeyboardNavigation,
  onResultClick,
  onResultOpenInNewTab,
  isOtherMatch = false
}) => {
  const { t } = useTranslation();
  const selectedItemRef = useRef<HTMLDivElement>(null);

  // Scroll selected item into view when selectedIndex changes
  useEffect(() => {
    if (selectedItemRef.current) {
      selectedItemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
      });
    }
  }, [selectedIndex]);

  return (
    <div
      data-test="global-search-results"
      role="listbox"
      aria-label={t("globalSearch.searchResults.ariaLabel")}
    >
      {results.map((result, index) => (
        <SearchResultItem
          key={`${result.entityType}-${result.id}`}
          result={result}
          isSelected={hasKeyboardNavigation && index === selectedIndex}
          onClick={() => onResultClick(result)}
          onOpenInNewTab={() => onResultOpenInNewTab(result)}
          isOtherMatch={isOtherMatch}
          ref={
            hasKeyboardNavigation && index === selectedIndex
              ? selectedItemRef
              : null
          }
          data-test={`global-search-result-${result.entityType}-${result.id}`}
        />
      ))}
    </div>
  );
};
